import { Link } from 'react-router-dom'
import ExternalIcon from '@/assets/icons/ExternalIcon'
import ClientSubmissionMark from '@/components/ModalValidation/MediaMarks/ClientSubmissionMark'
import PromotionalPackageMark from '@/components/ModalValidation/MediaMarks/PromotionalPackageMark'
import { VideoContainer } from './styles'

const VideoHolder = ({ url, ...mediaProps }) => {
  const route = `/attachment/${url}?type=video`

  return (
    <VideoContainer>
      <video width="200" height="200" src={url} controls />
      <ClientSubmissionMark url={url} {...mediaProps} />
      <PromotionalPackageMark url={url} {...mediaProps} />

      {route && (
        <div className="externalButton">
          <Link to={route} target="_blank" rel="noopener noreferrer">
            <ExternalIcon />
          </Link>
        </div>
      )}
    </VideoContainer>
  )
}

export default VideoHolder
